import { apiRequest } from "../util/apiUtils";

export const organizationList = async (params) => {
  try {
    const res = await apiRequest("get", `organization/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const taxonomyList = async (params) => {
  try {
    const res = await apiRequest("get", `taxonomy/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const taxonomyAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `taxonomy/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      }
      // "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const taxonomyDetails = async (payload) => {
  try {
    const res = await apiRequest("get", `/taxonomy/detail/${payload?.id}`);

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const taxonomyStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `taxonomy/status-change`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const taxonomyDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `taxonomy/delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
